class TestimonialsCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    window.loadSwiper.then((swiperLib) => {
      this.swiperLib = swiperLib;

      this._initCarousel();
    });
  }

  disconnectedCallback() {}

  _initCarousel() {
    const { Swiper } = this.swiperLib;

    const swiperParams = {
      slidesPerView: "auto",
      speed: 300,
      spaceBetween: 24,
      centerInsufficientSlides: true,
      navigation: {
        nextEl: this.querySelector("[data-navigation-next]"),
        prevEl: this.querySelector("[data-navigation-previous]"),
      },
      on: {
        lock: () => {
          this.classList.add("testimonials__carousel--locked");
        },
        unlock: () => {
          this.classList.remove("testimonials__carousel--locked");
        },
      },
    };

    this.swiper = new Swiper(this, swiperParams);
  }
}

if (!customElements.get("testimonials-carousel")) {
  customElements.define("testimonials-carousel", TestimonialsCarousel);
}
